export enum CustomerType {
  Normal = 'normal',
  IpNormal = 'iptvNormal',
  IpNormalBRL = 'iptvNormaliBrl',
}
